exports.version = "2.3.2"


//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-client/version.js
// module id = 314
// module chunks = 0